import React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { Control } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { generatePath, Link } from 'react-router-dom';

import type { GoToHandlerProps } from './types';
import { routes } from '../../../app/routes';

const displayName = 'GoToHandlerIconButton';
const testid = buildTestid(displayName);

function GoToHandlerIconButton({
  handlerId,
  className = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToHandlerProps & IconButtonProps): React.JSX.Element {
  return (
    <Control.IconButton
      className={className}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      variant="flat"
      {...testid(dataTestId)}
      {...props}
      as={Link}
      to={generatePath(routes.handlers.read, { handlerId })}
    />
  );
}

export { GoToHandlerIconButton };
